import { getProject } from '@haohan/clw-api'
import { getRouterPushUrl } from '@haohan/clw-utils'
import { ElMessage } from 'element-plus'
import { useProject } from '@haohan/clw-store'
import { filter } from 'lodash-es'

export const usePreviewHook = (id: string, router: any) => {
  const projectStore = useProject()

  const getPreviewPage = () => {
    const p = findFirstPage(
      filter(projectStore.pages, (p) => p.name !== 'ROOT' && p.title !== '非菜单页面')
    )
    return p
  }

  function findFirstPage(pages: any): any {
    let page
    for (let i = 0; i < pages.length; i++) {
      if (pages[i].type === 'PAGE') {
        page = pages[i]
        break
      } else if (pages[i].children && pages[i].children.length > 0) {
        page = findFirstPage(pages[i].children)
        if (page) {
          break
        }
      }
    }
    return page
  }

  // 跳转预览页面
  const toPreviewPage = async (shareId: string) => {
    const { data: projectData } = await getProject(id as string)
    projectStore.changeCurrentProject(projectData)
    await projectStore.updateModuleList()
    await projectStore.updateCurrentModule(projectStore.currentModuleList[0].id)
    const data = projectStore.pages
    if (
      !data?.length ||
      (data.length === 1 && (data[0].name === 'ROOT' || data[0].title === '非菜单页面'))
    ) {
      return ElMessage.info('还没有页面 先创建后再预览吧~')
    }

    const previewPage = getPreviewPage()
    const routeUrl = router.resolve({
      path: getRouterPushUrl({
        preFix: previewPage?.variables?.pageType === 'bigScreen' ? 'bigscreen' : 'preview',
        pageId: previewPage.id
      })
    })
    window.location.href = `${routeUrl.href}${shareId?.length ? '?shareId=' + shareId : ''}`
  }

  const getPreviewUrl = async (shareId: string) => {
    const { data: projectData } = await getProject(id as string)
    projectStore.changeCurrentProject(projectData)
    await projectStore.updateModuleList()
    await projectStore.updateCurrentModule(projectStore.currentModuleList[0].id)
    const data = projectStore.pages
    if (
      !data?.length ||
      (data.length === 1 && (data[0].name === 'ROOT' || data[0].title === '非菜单页面'))
    ) {
      return ElMessage.info('还没有页面 先创建后再预览吧~')
    }

    const previewPage = getPreviewPage()
    return `${getRouterPushUrl({
      preFix: previewPage?.variables?.pageType === 'bigScreen' ? 'bigscreen' : 'preview',
      pageId: previewPage.id
    })}${shareId?.length ? '?shareId=' + shareId : ''}`
  }

  return {
    toPreviewPage,
    getPreviewUrl
  }
}
